<template>
  <div class="admin-copy" v-if="copy">
    <navbar></navbar>
    <confirm ref="confirmdialog"></confirm>
    <h2>Edit Copy "{{copy.Signature}}"</h2>
   
    <edit-full-width caption="Edition">
      <select class="form-control" v-model="copy.EditionId" v-validate="'required'">
        <option v-for="e in editions" :value="e.Key">{{e.Value}}</option>
      </select>
    </edit-full-width>

    <edit-full-width caption="Location">
      <select class="form-control" v-model="copy.LocationId">
        <option v-for="l in locations" :value="l.Key">{{l.Value}}</option>
      </select>
    </edit-full-width>

    <edit-full-width caption="Consulted">
      <select class="form-control" v-model="copy.ConsultedId">
        <option v-for="c in consulted" :value="c.Key">{{c.Value}}</option>
      </select>
    </edit-full-width>

    <edit-full-width caption="Signature">
      <b-form-input v-model="copy.Signature" type="text" placeholder="Signature" ></b-form-input>
    </edit-full-width>

    <edit-full-width caption="Remarks">
      <vue-editor id="Remarks" v-model="copy.Remarks" :editorToolbar="customToolbar"></vue-editor>
    </edit-full-width>

    <edit-full-width caption="Users Traces">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Users Trace</th>
            <th>Explanation</th>
            <th>Pertaining to</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ut in copy.Userstraces.Items">
            <td>{{ut.UsersTrace}}</td>
            <td><span v-html="ut.ExplanationShort"></span></td>
            <td>{{ut.UsersTraceType}}</td>
            <td><b-button v-on:click="editUsersTrace(ut)">Edit</b-button><b-button v-on:click="deleteUsersTrace(ut)">Delete</b-button></td>
          </tr>
        </tbody>
      </table>
      <b-button v-on:click="addUsersTrace()">Add Users Trace</b-button>
    </edit-full-width>


    <edit-full-width caption="Links">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Url</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="l in copy.Links.Items">
            <td>{{l.Description}}</td>
            <td><a :href="l.Url" target="_blank">{{l.Url}}</a></td>
            <td><b-button v-on:click="editLink(l)">Edit</b-button><b-button v-on:click="deleteLink(l)">Delete</b-button></td>
          </tr>
        </tbody>
      </table>
      <b-button v-on:click="addLink()">Add Link</b-button>      
    </edit-full-width>


    <popup titel="Users Trace" ref="popupUsersTrace" @okclick="beforeSaveUsersTrace();" data-vv-scope="ut" >
      <template slot-scope="popup">
        <form v-if="popup.data != null" data-vv-scope="ut"> 
          <edit-full-width caption="Users Trace" :class="{'has-danger': errors.has('ut.UsersTrace') }" required="true">
              <select class="form-control" v-model="popup.data.UsersTraceId" name="UsersTrace" v-validate="'required'" >
                <option v-for="ut in userstraces" :value="ut.Key">{{ut.Value}}</option>
              </select>
          </edit-full-width>
          <edit-full-width caption="Pertaining to" :class="{'has-danger': errors.has('ut.UsersTraceType') }" required="true">
              <select class="form-control" v-model="popup.data.UsersTraceTypeId" name="UsersTraceType" v-validate="'required'" >
                <option v-for="utt in userstracetypes" :value="utt.Key">{{utt.Value}}</option>
              </select>
          </edit-full-width>
          <edit-full-width caption="Date" :class="{'has-danger': errors.has('ut.Date') }" required="true">
            <select class="form-control" v-model="popup.data.DateId" name="Date" v-validate="'required'">
              <option v-for="d in dates" :value="d.Key">{{d.Value}}</option>
            </select>
          </edit-full-width>
          <edit-full-width caption="Language" :class="{'has-danger': errors.has('ut.Language') }" required="true">
            <select class="form-control" v-model="popup.data.LanguageId" name="Language" v-validate="'required'">
              <option v-for="l in languages" :value="l.Key">{{l.Value}}</option>
            </select>
          </edit-full-width>
          <edit-full-width caption="Explanation">
            <vue-editor id="Explanation" v-model="popup.data.Explanation" :editorToolbar="customToolbar"></vue-editor>
          </edit-full-width>
          <b-alert variant="danger" :show="errors.any()">Errors</b-alert>
          <b-alert variant="light" :show="!errors.any()">&nbsp;</b-alert>
        </form>
     </template>
    </popup>


    <div class="row" style="margin-top:30px;margin-bottom:20px;">
      <span class="col-md-12 text-right">
        <b-alert variant="success" :show="saved" dismissible  @dismiss-count-down="countDownChanged" @dismissed="saved=0">Copy Saved</b-alert>
        <b-alert variant="warning" :show="saving">Saving......</b-alert>
        <b-button variant="primary" v-on:click="save(false)" v-if="!saving">Opslaan, Juffie</b-button>
        <b-button variant="primary" v-on:click="save(true)" v-if="!saving">Opslaan en sluiten</b-button>
        <b-button variant="secondary" v-on:click="cancel()" v-if="!saving">Annuleren</b-button>
      </span>
    </div>
  </div>
</template>

<script>

import navbar from '@/components/navbar.vue'
import Multiselect from 'vue-multiselect'
import EditFullWidth from '@/components/layout/edit-full-width.vue'
import { VueEditor } from 'vue2-quill-editor'
import Popup from '@/components/layout/popup.vue'
import Confirm from '@/components/layout/confirm.vue'

export default {
  name: 'admin-copy',
  components: {
    'navbar' : navbar,
    'Multiselect' : Multiselect,
    'edit-full-width' : EditFullWidth,
    'VueEditor' : VueEditor,
    'Popup' : Popup,
    'Confirm' : Confirm
  },
  data () {
    return {
      copy : null,
      editions : [],
      locations : [],
      userstraces : [],
      userstracetypes : [],
      consulted : [],
      languages : [],
      dates : [],
      customToolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['image']
          ],
      saved: 0,
      saving: false,
    }
  },
  methods: {
    loadcopy: function() {
      var data = {
        Id: this.$route.params.id
      };
      this.$http.post('x/pCopyDetails', data).then(function(response) { this.copy = response.data.Copy; this.saving = false; });
    },
    loaddata: function () {
      this.loadcopy();
      this.$http.post('pLookup', {"LookupName": "Edition"}).then(function(response) { this.editions = response.data; });
      this.$http.post('pLookup', {"LookupName": "Location"}).then(function(response) { this.locations = response.data; });
      this.$http.post('pLookup', {"LookupName": "Userstrace"}).then(function(response) { this.userstraces = response.data; });
      this.$http.post('pLookup', {"LookupName": "Consulted"}).then(function(response) { this.consulted = response.data; });
      this.$http.post('pLookup', {"LookupName": "Language"}).then(function(response) { this.languages = response.data; });
      this.$http.post('pLookup', {"LookupName": "UserstraceDate"}).then(function(response) { this.dates = response.data; });
      this.$http.post('pLookup', {"LookupName": "UsersTraceType"}).then(function(response) { this.userstracetypes = response.data; });
    },
    save: function (close) {
      this.saving = true;
      this.$http.post('x/pCopySave', {"Copy" : this.copy}).then(
        function(response) { 
            if (close==true) 
            {
              this.$router.push({ name: "AdminCopies" }); 
            }
            else
            {
              this.saved = 3;
              // Reload na saven
              this.loadcopy();
            }
        });
    }
    ,
    cancel: function () {
        this.$router.push({ name: "AdminCopies" });
    },
    editUsersTrace: function(cut) {
      this.$refs.popupUsersTrace.show(cut, this.copy.Userstraces.Items, this.$validator, this.errors);
    },
    deleteUsersTrace: function(cut) {
      var data = this;
      this.$refs.confirmdialog.confirm("Delete Users Trace?",
        function() {
          var i = data.copy.Userstraces.Items.indexOf(cut);
          if (i != -1) data.copy.Userstraces.Items.splice(i, 1);
        });
    },
    addUsersTrace: function() {
      this.$refs.popupUsersTrace.show({ Explanation : ""}, this.copy.Userstraces.Items, this.$validator, this.errors);
      
    },
    beforeSaveUsersTrace: function() {
      var data = this.$refs.popupUsersTrace.getData();
      data.UsersTrace = this.getByValue(this.userstraces, data.UsersTraceId);
      data.UsersTraceType = this.getByValue(this.userstracetypes, data.UsersTraceTypeId); 
      data.ExplanationShort = data.Explanation && data.Explanation.length > 20 ? data.Explanation.substring(0,20) : data.Explanation;
    },
    editLink: function() {},
    deleteLink: function() {},
    addLink: function() {},
    getByValue: function (arr, value) {
      var result  = arr.filter(function(o){return o.Key == value;});
      return result? result[0].Value : null; 
    },
    countDownChanged (dismissCountDown) {this.saved = dismissCountDown; },
  },
  created: function() {
	 this.loaddata();
  }
}
</script>       

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}
#Remarks { height: auto; }
</style>



// WEBPACK FOOTER //
// admin-copy.vue?ed547068